import TableCell from "../../CertificateTable/TableCell";
import CertificateStatus from "../../CertificateStatus";
import {
  createTestReportCertificateLink,
  createTestReportLink,
} from "../../../helpers/urlBuilder";
import CertificateFileLink from "../../CertificateFileLink";
import { formatDate } from "../../../helpers/date";

const TestRecord = ({ testRecord, company }) => {
  return (
    <>
      <TableCell size={2} clearBorderTop clearBorderLeft center>
        {formatDate(testRecord.testDate, {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        }).replace(/\./ig, '-')}
      </TableCell>
      <TableCell size={4} clearBorderTop clearBorderLeft center>{testRecord.testMessage}</TableCell>
      <TableCell size={2} clearBorderTop clearBorderLeft center>
        <>
          {
            testRecord?.certificateFileDE ? (
              <CertificateFileLink fileUrl={createTestReportCertificateLink(company?.id, testRecord?.id, 'de')}
                                   title={'DE'} instaDownload />
            ) : null
          }
          &nbsp;
          {
            testRecord?.certificateFileEN ? (
              <CertificateFileLink fileUrl={createTestReportCertificateLink(company?.id, testRecord?.id, 'en')}
                                   title={'EN'} instaDownload />
            ) : null
          }
        </>
      </TableCell>
      <TableCell size={2} clearBorderTop clearBorderLeft center>
        {
          testRecord.testReportFile ? (
            <CertificateFileLink
              fileUrl={createTestReportLink(testRecord?.id)} title={testRecord.certificateNumber}
              instaDownload
            />
          ) : null
        }
      </TableCell>
      <TableCell size={2} clearBorderTop clearBorderLeft center>
        <CertificateStatus status={testRecord.status} />
      </TableCell>
    </>
  )
}

export default TestRecord;